module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/._babel-runtime@6.23.0@babel-runtime/core-js/is-iterable.js
 ** module id = 366
 ** module chunks = 0 1
 **/